import { yupResolver } from "@hookform/resolvers/yup";
import { TMyEventsItem } from "apiTypes";
import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as Yup from "yup";
import useUtilities from "../../customHooks/useUtilities";
import { isEmpty } from "../../utils/isEmpty";
import Step1 from "../Create/Steps/Step1";
import Step2 from "../Create/Steps/Step2";
import Step3 from "../Create/Steps/Step3";
import Step4 from "../Create/Steps/Step4";
import Step5 from "../Create/Steps/Step5";
type Props = {
  showEditEventModal: boolean;
  handleCloseEditEventModal: () => void;
  onFormSubmit: (data: TMyEventsItem) => void;
  selectedItem: TMyEventsItem;
};
const EditEventModal = ({
  showEditEventModal,
  handleCloseEditEventModal,
  onFormSubmit,
  selectedItem,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation("common");
  const { data: utilities } = useUtilities();

  const defaultValues = {
    title: "",

    details: "",
    preview_image: "",
    private: false,
    ///
    approved_terms: false,
  };
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .min(10, t("min_x_invalid", { x: t("10") }))
      .max(250, t("max_x_invalid", { x: t("250") }))
      .required(t(`field_required`)),
    //validation for step2

    details: Yup.string()
      .min(30, t("min_x_invalid", { x: t("30") }))
      .max(250, t("max_x_invalid", { x: t("250") }))
      .required(t(`field_required`)),
    //validation for step3
    preview_image: Yup.mixed().not([""], t("field_required")),
    //validation for step4
    private: Yup.bool().required(t("field_required")),
    //validation for step5
    approved_terms: Yup.bool().oneOf([true], t("field_required")),
  });

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isDirty, isValid },
  } = methods;
  useEffect(() => {
    if (selectedItem) {
      reset({
        title: selectedItem.content.title,

        details: selectedItem.content.details,
        private: selectedItem?.private ? true : false,
      });
    }
  }, [selectedItem]);

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await onFormSubmit(data);

      handleCloseEditEventModal();
    } catch (err) {}
    setIsLoading(false);

    // alert(data);
    // handleNext();
  };
  const data = useMemo(
    () => utilities?.target_types?.["event"]?.["categories"],
    [utilities]
  );
  return (
    <MolhamModalOffcanvas
      size="lg"
      header={{
        label: `${t(`edit_on`)} ${selectedItem?.content?.short_name}`,
      }}
      fullscreen
      swipeToClose={false}
      show={showEditEventModal}
      onHide={handleCloseEditEventModal}
    >
      <FormProvider {...methods}>
        <form
          className={`${!isEmpty(errors) ? "invalid" : ""}`}
          onSubmit={handleSubmit(onSubmit)}
          encType=""
        >
          <div>
            <Step1 data={data} />
            <Step2 isProfile={true} />
            <Step3
              isEditModal={true}
              editedImg={selectedItem?.preview_image?.original}
            />
            <Step4 />
            <Step5 />
          </div>
          <div className="d-flex justify-contnet-center">
            <MolhamButton
              id="edit-event-btn"
              label={t(`edit`)}
              disabled={!isDirty || !isValid}
              isLoading={isLoading}
              className="w-100"
              startIcon="fe-edit fs-lg"
              onClick={handleSubmit(onSubmit)}
            />
          </div>
        </form>
      </FormProvider>
    </MolhamModalOffcanvas>
  );
};

export default EditEventModal;
